import { gql } from '@apollo/client';
import { getDomainGraphqlError, useMutation$ } from 'graphqlsupport';
import { useCallback } from 'react';
import { FullProviderUserInfo, NewProviderUserMutationInput } from '../../../domain/types';
import {showToast} from "common";

type NewProviderUserMutationResult = {
    newProviderUser: FullProviderUserInfo,
};
export const CREATE_PROVIDER_USER_MUTATION = gql`
mutation newProviderUser($input: NewProviderUserInput) {
  newProviderUser(payload: $input) {
    oktaId
    username
    email
    firstName
    lastName
    providerName
    status
    clientPlacementAccess
    clientReportAccess
    providerMetricsAccess
    rosterAccess
    auditLogAccess
    contactEditAccess
    contactReadAccess
    userManagementAdminAccess
  }
}
`;
export const useNewProviderUserMutation$ = (successCallback: () => void) => {
    const { execute, isRunning$, } = useMutation$<{ input: NewProviderUserMutationInput }, NewProviderUserMutationResult>(CREATE_PROVIDER_USER_MUTATION);
    const wrappedExecute = useCallback(async (input: NewProviderUserMutationInput) => {
        try {
            const { data } = await execute({
                variables: {
                    input,
                },
            });
            if (data) {
                showToast.success(`User created successfully with ID ${data.newProviderUser.oktaId}`);
                successCallback();
            }
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to create user. ${errors.message || errors[0].message}`);
            }
        }
    }, [execute, successCallback]);
    return {
        isRunning$,
        submit: wrappedExecute,
    };
}
